export default "__VITE_ASSET__9kNfJ3hE__"